/* eslint-disable no-undef */
export function triggerResponsiveNav() {
  if (!$().dlmenu) return;
  $('#dl-menu').dlmenu()
}
